module.exports = __webpack_public_path__ + "img/27de2921d0d209dce9d63242998ad388.svg";